import Dialog from "@material-ui/core/Dialog";
import React from "react";
import "./SuccessDialog.scss";
import { agentsList } from "../../../agentsList";

export const SuccessDialog = ({ dialog, setDialog }) => {
  return (
    <Dialog maxWidth="sm" fullWidth open={dialog} onClose={() => setDialog(false)} className="successDialog">
      <div className="successDialog__logo">
        <img src={require("../../../assets/img/login_transpadent_dark.png")} alt="" />
      </div>

      <h2>Заявка создана успешно!</h2>
      <p>Для завершения заказа обратитесь к представителю компании:</p>

      {agentsList.map(({ id, location, name, tel }) => (
        <div className="successDialog__agent" key={id}>
          <h4>{location}:</h4>
          <h4>{name}</h4>
          <a href={`tel:${tel.replace(/ /g, "")}`}>{tel}</a>
        </div>
      ))}

      {/*<div className="successDialog__agent">*/}
      {/*  <h4>Харьков:</h4>*/}
      {/*  <h4>Компания Ortho Max</h4>*/}
      {/*  <a href="tel:+38 067 632 49 52">+38 067 632 49 52</a>*/}
      {/*</div>*/}

      {/*<div className="successDialog__agent">*/}
      {/*  <h4>Днепр, Запорожье:</h4>*/}
      {/*  <h4>Компания Ortho Liberty</h4>*/}
      {/*  <a href="tel:+38 067 632 51 04">+38 067 632 51 04</a>*/}
      {/*</div>*/}

      {/*<div className="successDialog__agent">*/}
      {/*  <h4>Киев и другие области:</h4>*/}
      {/*  <h4>Компания Ortho Riches</h4>*/}
      {/*  <a href="tel:+38 099 414 44 58">+38 099 414 44 58</a>*/}
      {/*</div>*/}

      {/*<div className="successDialog__agent">*/}
      {/*  <h4>Львов, Ивано-Франковск, Ровно, Черновцы, Хмельницкий, Закарпатская область:</h4>*/}
      {/*  <h4>Компания 3D Dental</h4>*/}
      {/*  <a href="tel:+38 068 635 23 05">+38 068 635 23 05</a>*/}
      {/*</div>*/}
    </Dialog>
  );
};
